import React from "react";
import { motion } from "framer-motion";

const products = [
  {
    name: "Roller Shades",
    image: "https://comfieblinds.ca/product_catalog/547901672488971.png",
    description: "Sleek, modern, and easy to maintain.",
  },
  {
    name: "Zebra Blinds",
    image: "https://comfieblinds.ca/product_catalog/103621672489116.jpg",
    description: "Combines sheer and solid fabric for light control.",
  },
  {
    name: "2' Inch Faux Wood Blinds",
    image: "https://comfieblinds.ca/product_catalog/187521674259498.jpg",
    description: "Classic wooden look with extra durability.",
  },
  {
    name: "Vertical Blinds",
    image: "https://comfieblinds.ca/product_catalog/230211672489061.jpg",
    description: "Ideal for large windows and patio doors.",
  },
  {
    name: "Honeycomb/Cellular Shades",
    image: "https://comfieblinds.ca/product_catalog/849401706058999.webp",
    description: "Energy-efficient design with a soft aesthetic.",
  },
];

const TopSellingBlinds = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="bg-gradient-to-br from-[#003EA1] to-[#01A9DE] py-20 px-8 lg:px-24 text-center relative overflow-hidden"
    >
      {/* Animated Background Glow */}
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{ opacity: [0.3, 0.6, 0.3] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        style={{
          background: "radial-gradient(circle, rgba(255,255,255,0.1) 20%, transparent 80%)",
        }}
      ></motion.div>

      {/* Title Section */}
      <motion.h1
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white drop-shadow-xl"
      >
        Discover Our Bestsellers
      </motion.h1>
      <motion.p
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="text-lg sm:text-xl text-white mt-5 mb-16"
      >
        Elevate your space with the most loved window blinds.
      </motion.p>

      {/* Product Cards - Responsive Layout */}
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-10 justify-items-center py-10">
        {products.map((product, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            whileHover={{ scale: 1.08 }}
            className="relative max-w-[250px] md:max-w-[300px] lg:max-w-[320px] w-full h-80 bg-gradient-to-br from-[#003EA1] via-[#0274BD] to-[#01A9DE] backdrop-blur-xl rounded-3xl shadow-2xl flex flex-col items-center p-6 transition-all duration-300 border border-white/30 hover:shadow-2xl hover:border-[#01A9DE] hover:border-opacity-70"
          >
            {/* Glowing Border Effect */}
            <div className="absolute inset-0 border-2 border-transparent rounded-3xl transition-all duration-500 hover:border-[#01A9DE]"></div>

            {/* Product Image with Glow & Reflection */}
            <motion.div
              className="relative w-44 h-44 rounded-xl overflow-hidden shadow-lg bg-white flex justify-center items-center"
              whileHover={{ y: -10, scale: 1.05 }}
            >
              <motion.img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-cover transition-transform duration-500"
                whileHover={{ scale: 1.15, rotate: -3 }}
              />
              {/* Reflection Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-transparent to-white/20 opacity-40"></div>
            </motion.div>

            {/* Product Name with Neon Glow */}
            <motion.p
              className="text-lg font-extrabold text-white mt-4 tracking-wide uppercase"
              whileHover={{ scale: 1.08, textShadow: "0px 0px 10px rgba(255,255,255,0.8)" }}
            >
              {product.name}
            </motion.p>

            {/* Product Description with Fading Effect */}
            <motion.p
              className="text-sm text-gray-200 mt-2 text-center opacity-80 transition-all duration-300"
              whileHover={{ opacity: 1, color: "white" }}
            >
              {product.description}
            </motion.p>

            {/* Glowing Effect on Hover */}
            <motion.div
              className="absolute inset-0 bg-white opacity-0 transition-all duration-500 rounded-3xl"
              whileHover={{ opacity: 0.08 }}
            />
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default TopSellingBlinds;
